<div style="font-size: 13px; display: flex; height: 38px; justify-content: space-between; flex-grow: 1; align-items: center"
  class="main-container">
  <div id="review-status" style="padding-left: 20px;">
    <div *ngIf="reviewStatus !== null">
      <div *ngIf="reviewStatus !== 0" class="reviewed-by-row" style="display: flex; align-items: center;">
        <i class="fa-duotone fa-badge-check" style="--fa-primary-color: white;
        --fa-secondary-color: green; --fa-secondary-opacity: 1; margin-right: 8px; font-size: 14px;"></i>
        <div *ngIf="reviewStatus === 1">Document Reviewed by Me</div>
        <div *ngIf="reviewStatus === 2">Document Reviewed by Others</div>
        <div *ngIf="reviewStatus === 3">Reviewed by Me and Others</div>
      </div>
      <div *ngIf="reviewStatus === 0" class="reviewed-by-row" style="display: flex; align-items: center;">
        <i class="fa-duotone fa-file-exclamation reviewed-by-node"></i>
        <div>Document has not been reviewed.</div>
      </div>
    </div>
  </div>
  <div id="content-info">
    <div *ngIf="(documentView$ | async) === 'pages' && hasPdf">
      <div style="display:flex; flex-direction:row; align-items: center; gap: 4px;">
        <button (click)="goToPreviousPage()" [disabled]="currentPage === 1" matTooltip="Previous Page" 
        [ngClass]="{'temp-icon': currentPage !== 1, 'disabled': currentPage === 1}" style="display: flex; border: unset;">
          <i class="fa-duotone fa-angle-left" style="font-size: 16px !important;"></i>
        </button>
        <div>
          <div #pageMenuSelector style="display:flex; align-items: center; gap: 4px;">
            <div style="align-self: center;">Page</div>
            <div style="text-wrap: nowrap;">
              {{currentPageDisplayValue}}
            </div>
            <div *ngIf="pages?.length > 1" [matMenuTriggerFor]="pageSelect" style="cursor: pointer;" (menuOpened)="pageMenuOpened()">
              <i class="fa-duotone fa-caret-down"></i>
            </div>
            <div>of</div>
            <div style="align-self: center;">{{pages?.length}}</div>
          </div>
        </div>
        <button (click)="goToNextPage()" [disabled]="currentPage >= pages?.length" matTooltip="Next Page"
        [ngClass]="{'temp-icon': currentPage < pages?.length, 'disabled': currentPage >= pages?.length}" style="display: flex; border: unset;">
          <i class="fa-duotone fa-angle-right"style="font-size: 16px !important;"></i>
        </button>
        <mat-menu class="doc-viewer-menu" #pageSelect yPosition="below" xPosition="before">
          <cdk-virtual-scroll-viewport itemSize="48" style="min-width: 100%;"
                                       [style.height.px]="pages?.length > 5 ? 240 : pages?.length * 48" [style.width.px]="pageMenuSelector.clientWidth">
            <menu mat-menu-item *cdkVirtualFor="let page of pages; index as i;" 
            [ngClass]="{'selected':currentPage === i + 1}" 
            (click)="goToPage(i + 1)">
             <div>{{page}}</div> 
            </menu>
          </cdk-virtual-scroll-viewport>
        </mat-menu>
      </div>
    </div>
    <div *ngIf="(documentView$ | async) === 'produced' && hasProduction">
      <div *ngIf="productionDocs?.length === 1"  style="margin: auto;">
        {{productionDocs[0][1]}}</div>
      <div *ngIf="productionDocs?.length > 1"  style="display:flex; flex-direction:row; align-items: center; gap: 4px;">
        <div>
          {{selectedProduction[1]}}
        </div>
        <div [matMenuTriggerFor]="productionSelect" style="cursor: pointer;">
          <i class="fa-duotone fa-caret-down"></i>
        </div>
        <mat-menu class="doc-viewer-menu" #productionSelect yPosition="below" xPosition="before">
          <menu mat-menu-item *ngFor="let prod of productionDocs" 
          [ngClass]="{'selected':selectedProduction[0] === prod[0]}" 
          (click)="selectedProducedDocChanged(prod)">
            {{prod[1]}}
          </menu>
        </mat-menu>
      </div>
    </div>
  </div>
  <div id="review-progress" *ngIf="mode === 'review'" style="margin: 7px 15px; display:flex; flex-direction: row;gap: 8px;
        align-items: center;">
    <div>Documents Remaining: {{remainingReviewDocCount || 0}}</div>
    <div style="margin: 10px 0;">Documents Reviewed: {{reviewedByMeCount || 0}}</div>
  </div>
  <div id="navigation" *ngIf="mode !== 'review'" style="display:flex; align-items: center;">
    <div style="margin-right: 8px;">
      Document {{(currentDocIndex$ | async) + 1}} of {{(totalDocs$ | async)}}
    </div>
    <button id="new-doc-viewer-
    evious-document-button" (click)="previousDoc()"
      [disabled]="(currentDocIndex$ | async) === 0" matTooltip="Previous Document"
      [ngClass]="{'temp-icon': (currentDocIndex$ | async) !== 0, 'disabled': (currentDocIndex$ | async) === 0}" style="width: 55px;border: unset; cursor: pointer;">
      <i class="fad fa-chevrons-left"></i>
    </button>
    <button id="new-doc-viewer-next-document-button" (click)="nextDoc()"
      [disabled]="(currentDocIndex$ | async) === (totalDocs$ | async) - 1" matTooltip="Next Document"
      [ngClass]="{'temp-icon': (currentDocIndex$ | async) !== (totalDocs$ | async) - 1, 'disabled': (currentDocIndex$ | async) === (totalDocs$ | async) - 1}"
      style="width: 55px;border: unset; cursor: pointer;">
      <i class="fad fa-chevrons-right"></i>
    </button>
  </div>
</div>
